import type { UseQueryOptions } from "react-query/types/react/types";
import { useApiGet } from "src/shared/actions/FetchActions";
import { useQuery } from "react-query";
import { UTILS_API_PATH } from "src/confs/APIConfig";
import type { Timezone } from "src/shared/objects/Timezone";

export const useTimezones = (
  countryCode: string,
  regionCode: string,
  options?: UseQueryOptions<
    Timezone[],
    unknown,
    Timezone[],
    ["timezones", string, string]
  >,
) => {
  const apiGet = useApiGet();
  return useQuery(
    ["timezones", countryCode, regionCode],
    async () => {
      const { data } = await apiGet<Timezone[]>(
        `${UTILS_API_PATH}/timezones/${countryCode}/${regionCode}`,
      );
      return data;
    },
    options,
  );
};
